export default __webpack_public_path__ + "static/media/whole_school_day.a3a2acb3.jpg";